import React from 'react';
import { Layout } from 'antd';
import styled from '@emotion/styled';
import { appStyles } from '../../../styles';

const { Content } = Layout;

export const TopStories = () => {
  return (
    <>
      <Container>
        <Content>TopStories</Content>
      </Container>
    </>
  );
};

const Container = styled.div`
  ${appStyles.paddingComponent}

  & .ant-pagination {
    float: right;
    padding: 15px 0 0 0;
  }

  .btn-generate-access-code,
  .btn-export-access-code {
    width: 140px;
  }
`;
